import React from 'react';
import {createRoot} from 'react-dom/client';
import {ConfigProvider} from 'antd';
import PortalLogin from './PortalLogin';
import {PORTAL_ANTD_THEME} from './portalTheme';
import {setRecaptchaSiteKey} from './recaptcha';

const rootElement = document.getElementById('portal-login-root');

if (rootElement) {
    setRecaptchaSiteKey(rootElement.dataset.recaptchaSiteKey);

    const root = createRoot(rootElement);
    root.render(
        <ConfigProvider theme={PORTAL_ANTD_THEME}>
            <PortalLogin/>
        </ConfigProvider>
    );
}
